import { createContext, useContext } from "react";

export interface HelpDrawerCtx {
  open: boolean;
  openDrawer: (query?: string) => void;
  closeDrawer: () => void;
}

export const HelpDrawerContext = createContext<HelpDrawerCtx>({
  open: false,
  openDrawer: () => {},
  closeDrawer: () => {},
});

export function useHelpDrawer(): HelpDrawerCtx {
  return useContext(HelpDrawerContext);
}
